import React from "react"

import { connect } from "scrivito"
import { PortalNewsPageObj } from "scrivito/Objs/PortalNewsPage/PortalNewsPageObjClass"

import { ScrivitoPortalNewsListModel } from "widgets/portal-news-list/ScrivitoPortalNewsList"

import { PortalNewsOverlay } from "./PortalNewsOverlay"
import { usePortalNewsOverlayModel } from "./hooks/usePortalNewsOverlayModel"

export interface PortalNewsOverlayModel {
  page: PortalNewsPageObj | null | undefined
  listModel: ScrivitoPortalNewsListModel
  onClose: () => void
}

export function PortalNewsOverlayConnectorComponent() {
  return <PortalNewsOverlay {...usePortalNewsOverlayModel()} />
}

export const PortalNewsOverlayConnector = React.memo(
  connect(PortalNewsOverlayConnectorComponent)
)

declare module "shared/context/overlay/registry" {
  interface OverlayPayloadRegistry {
    PORTAL_NEWS_OVERLAY: null
  }
}
